<template>
  <form-page-template>
    <div class="uc-form">
      <h1 class="uc-form-header">{{ $t('resetPassword.header') }}</h1>
      <p v-if="!error && !msg" class="uc-form-text">
        {{ $t('resetPassword.text') }}
      </p>

      <div v-if="error" class="alert alert-danger" role="alert">
        {{ error }}
      </div>

      <div v-if="msg" class="uc-form-text message">{{ msg }}</div>

      <form v-else>
        <div class="uc-form-element">
          <label for="inputEmail" class="uc-form-label">{{
            $t('resetPassword.emailLabel')
          }}</label>
          <input
            id="inputEmail"
            class="uc-form-text-input"
            type="email"
            :placeholder="$t('resetPassword.emailPlaceholder')"
            v-model="email"
            required
            autofocus
          />
        </div>

        <button
          class="uc-form-button"
          type="submit"
          @click.prevent="submit()"
          :disabled="isSendingEmail"
        >
          {{ $t('resetPassword.submitButton') }}
        </button>
      </form>

      <loader v-if="isSendingEmail" overlay />
      <i18n
        v-if="!error && !msg"
        path="resetPassword.rememberPassword"
        tag="p"
        class="uc-form-text"
      >
        <router-link class="uc-link" :to="`/${$i18n.locale}/login`">{{
          $t('resetPassword.login')
        }}</router-link>
      </i18n>
    </div>
  </form-page-template>
</template>

<script>
import AuthService from '@/services/AuthService'
import FormPageTemplate from '@/components/FormPageTemplate.vue'
import Loader from '@/components/Loader.vue'
import LoggerService from '@/services/LoggerService'

export default {
  components: {
    FormPageTemplate,
    Loader,
  },
  created() {
    this.$store.dispatch('app/hideNavigation')
  },
  data() {
    return {
      email: '',
      msg: '',
      error: '',
      isSendingEmail: false,
    }
  },
  methods: {
    submit() {
      this.isSendingEmail = true
      this.error = ''
      AuthService.sendReset(this, this.email)
        .then(() => (this.isSendingEmail = false))
        .catch(err => {
          this.error =
            err?.response?.data?.err ?? this.$root.$t('resetPassword.error')
          this.isSendingEmail = false
          if (err?.response?.status !== 422) {
            LoggerService.noticeError(err)
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.uc-form-text {
  text-align: center;

  &.message {
    margin-top: 40%;
  }
}
</style>
